import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Home, Search } from 'lucide-react'
import SEO from '../components/SEO'

export default function NotFound() {
  useEffect(() => {
    document.title = '404 — Страница не найдена | Chat-Neuro.ru'
  }, [])

  return (
    <>
      <SEO title="404 — Страница не найдена | Chat-Neuro.ru" description="Страница не найдена. Возможно, она была удалена или вы перешли по неверной ссылке." noIndex />
      <div className="min-h-screen flex items-center justify-center p-4" style={{ background: '#0f0f1a' }}>
        <div className="text-center max-w-md">
          <div className="text-8xl font-bold gradient-text mb-4">404</div>
          <h1 className="text-xl font-semibold text-white mb-2">Страница не найдена</h1>
          <p className="text-sm text-gray-500 mb-8">
            Возможно, страница была удалена или вы перешли по неверной ссылке
          </p>
          <div className="flex items-center justify-center gap-3">
            <Link
              to="/"
              className="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-500 hover:to-purple-500 text-sm font-medium text-white transition-all shadow-lg shadow-indigo-600/20"
            >
              <Home className="w-4 h-4" />
              На главную
            </Link>
            <Link
              to="/chat"
              className="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-white/5 hover:bg-white/10 text-sm text-gray-300 transition-all"
            >
              <Search className="w-4 h-4" />
              Перейти в чат
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
